// extracted by mini-css-extract-plugin
export default {"changelogTitle":"styles-module--changelogTitle--6oMoW"};